module.exports = __webpack_public_path__ + "static/media/UZ.6bf657fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/UZ.svg
// module id = 386
// module chunks = 0